var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80762 2.80761L1.3934 4.22182L4.02597 6.85439C1.5559 8.68901 0 10.9237 0 12C0 14 5.37258 20 12 20C13.5291 20 14.9913 19.6806 16.3362 19.1647L19.7782 22.6066L21.1924 21.1924L2.80762 2.80761ZM7.4 12C7.4 11.4689 7.49002 10.9587 7.65564 10.4841L9.00457 11.833C9.00154 11.8883 9 11.944 9 12C9 13.6569 10.3431 15 12 15C12.056 15 12.1117 14.9985 12.167 14.9954L13.5159 16.3444C13.0413 16.51 12.5311 16.6 12 16.6C9.45949 16.6 7.4 14.5405 7.4 12Z",
    fill: "#18213A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66377 4.83534L10.4841 7.65564C10.9587 7.49002 11.4689 7.4 12 7.4C14.5405 7.4 16.6 9.45949 16.6 12C16.6 12.5311 16.51 13.0413 16.3444 13.5159L19.974 17.1456C22.4441 15.311 24 13.0763 24 12C24 10 18.6274 4 12 4C10.4709 4 9.00867 4.31938 7.66377 4.83534Z",
    fill: "#18213A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9954 12.167C14.9985 12.1117 15 12.056 15 12C15 10.3431 13.6569 9 12 9C11.944 9 11.8883 9.00154 11.833 9.00457L14.9954 12.167Z",
    fill: "#18213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.9f6479e5b044253ee4f56a5fcbe3e2f8.svg";
export { ForwardRef as ReactComponent };